import React from 'react'

const IcCopy = () => {
  return (
    <svg
  xmlns="http://www.w3.org/2000/svg"
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
>
  <path
    d="M10.8329 5.41666L11.9696 4.26779C12.9459 3.29148 14.5288 3.29148 15.5051 4.26779C16.4814 5.2441 16.4814 6.82701 15.5051 7.80332L11.9696 11.3389C10.9933 12.3152 9.41037 12.3152 8.43406 11.3389M9.16629 14.1667L7.80292 15.5055C6.82661 16.4818 5.2437 16.4818 4.26739 15.5055C3.29108 14.5292 3.29108 12.9463 4.26739 11.97L7.80292 8.43445C8.77923 7.45814 10.3621 7.45814 11.3385 8.43445"
    stroke="#007BFF"
    strokeWidth="1.5"
    strokeLinecap="round"
  />
</svg>


  )
}

export default IcCopy